export const isAgenticOnboardingPropertyEnabled = (experimentUtil) => experimentUtil.isTestVariant('SHARED_SOURCE_AGENTIC_ONBOARDING');

export const isEnUsPermanentFeatureVrEnabled = (experimentUtil) => experimentUtil.isTestVariant('ULX_EN_US_PERMANENT_FEATURE_VR');

export const isConfirmAddressFeatureEnabled = (experimentUtil) => experimentUtil.isTestVariant('ULX_ADDRESSV2_VR');

export const getVacasaVariant = (experimentUtil) => experimentUtil.getExperimentDataByName('ULX_PM_VACASA')?.value ?? 0;

export const isValuePropBannerActive = (experimentUtil) => experimentUtil.isTestVariant('ULX_VALUE_PROP_BANNER') || experimentUtil.isTestVariant('ULX_VALUE_PROP_BANNER_CL');

export const getCLStickBannerVariant = (experimentUtil) => experimentUtil.getExperimentDataByName('ULX_CL_STICKY_ABC')?.value ?? 0;

export const isVrboUplEnabled = (experimentUtil) => experimentUtil.isTestVariant('ULX_UPL_VRBO');

export const isArxRedirectEnabled = (experimentUtil) => experimentUtil.isTestVariant('DIRECT_TO_ARX');

export const isSharedSpaceDeflectionEnabled = (experimentUtil) => experimentUtil.isTestVariant('ULX_SHARED_SPACE_DEFLECTION_VR');
